import PropTypes from 'prop-types';
import React from 'react';
import RedesignedMentionsPing from './redesigned_mentions_ping';

class RelatedWorksPing extends RedesignedMentionsPing {
  getBody() {
    let article = $h.aOrAn(this.props.researchInterestName);
    article = article.charAt(0).toUpperCase() + article.slice(1);

    return (
      <div className="text">
        {article} <strong>{this.props.researchInterestName}</strong> paper
        similar to <strong>{this.props.currentWorkTitle}</strong> mentions the
        name <strong>"{this.props.mentionedName}"</strong>
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'single-work-page-related-works-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }
}

RelatedWorksPing.propTypes = {
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
  currentWorkTitle: PropTypes.string.isRequired,
};

export default RelatedWorksPing;
